module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1 calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('img', {
    attrs: {
      "alt": "titlepage",
      "src": "Images/titlepage.jpg"
    }
  }), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', [_c('img', {
    staticClass: "generated-style",
    attrs: {
      "alt": "A grayscale.jpg",
      "src": "Images/00003.jpeg"
    }
  })]), _c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-229-0-override"
  }, [_c('span', {
    staticClass: "no-style-override"
  }, [_c('a', {
    attrs: {
      "href": "http://WildBluePress.com",
      "target": "_blank"
    }
  }, [_vm._v("WildBluePress.com")]), _c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dabe9188","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/titlepage.vue
// module id = 60
// module chunks = 0